<template>
  <MenuOrganization
    v-if="deepAdminUsersMeStore.selectedOrganization"
    :hide-menu-icon="
      hideMenuIcon ||
      deepAdminUsersMeStore.getUserSelectableOrganizations.length <= 1
    "
    :is-menu-disabled="
      isMenuDisabled ||
      deepAdminUsersMeStore.getUserSelectableOrganizations.length <= 1
    "
    :organizations="deepAdminUsersMeStore.getUserSelectableOrganizations"
    :selected-organization="deepAdminUsersMeStore.selectedOrganization"
    @change:organization="onChangeOrganization"
  />
</template>
<script lang="ts" setup>
import { useDeepAdminUsersMeStore } from '@/stores/deepadmin/users/users-me.ts'
import MenuOrganization from '@/components/menu/MenuOrganization.vue'
import type { UserMeOrganization } from '@deepcloud/api-deep-admin'

defineProps({
  isMenuDisabled: {
    type: Boolean,
    default: false,
  },
  hideMenuIcon: {
    type: Boolean,
    default: false,
  },
})

const router = useRouter()
const deepAdminUsersMeStore = useDeepAdminUsersMeStore()

async function onChangeOrganization(organization: UserMeOrganization) {
  if (deepAdminUsersMeStore.selectedOrganizationId !== organization.group_id) {
    deepAdminUsersMeStore.selectOrganization(organization)

    void router.push({
      name: 'organization',
      params: { organization: organization.group_id },
    })
  }
}
</script>
